/**
 * Objektrepresentation för en definierad egenskapstyp.
 */
import { EgenskapsVardeTyp } from './egenskapsVardeTyp';

export interface EgenskapsTyp {
  /**
   * Anger unik stabil identitet för egenskapstypen.
   */
  egenskapstyp: EgenskapsTyp.EgenskapstypIdEnum;
  /**
   * Anger namnet för angiven egenskapstyp (lämpligt för presentation).
   */
  namn: string;
  /**
   * Anger beskrivning för angiven egenskapstyp. (lämpligt för hjälptext).
   */
  beskrivning: string | null;
  /**
   * Anger om typen är aktiv (true) och kan användas vid registrering eller ej.
   */
  aktiv: boolean;
  /**
   * Anger sorteringsordningen för typen.
   */
  sorteringsordning: number;
  egenskapsvarden: EgenskapsVardeTyp[];
}
export namespace EgenskapsTyp {
  export type EgenskapstypIdEnum = 'FASADMATERIAL' | 'STOMME' | 'TAKFORM' | 'TAKTACKNINGSMATERIAL';
  export const EgenskapstypIdEnum = {
    FASADMATERIAL: 'FASADMATERIAL' as EgenskapstypIdEnum,
    STOMME: 'STOMME' as EgenskapstypIdEnum,
    TAKFORM: 'TAKFORM' as EgenskapstypIdEnum,
    TAKTACKNINGSMATERIAL: 'TAKTACKNINGSMATERIAL' as EgenskapstypIdEnum
  };
}
